import * as React from 'react';

export const SweetPanel = ({ children }) => {
  return (
    <div className="SweetPanel">
      { children }
    </div>
  )
}
